import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import {
  selectAiChatActivityPhase,
  selectAiChatRunningToolFriendlyName,
} from 'store/aiChat/selectors';

import { AiChatTestIds } from '../../AiChat.testIds';
import { OmegaIcon } from '../../icons';

import { ACTIVITY_ICON_SIZE, RUNNING_TOOL_HOLD_MS } from './AiChatActivityBar.constants';
import { activityBarStyles } from './AiChatActivityBar.styles';
import { resolveActivityState } from './AiChatActivityBar.utils';
import useStickyRunningToolPhase from './hooks/useStickyRunningToolPhase';

const AiChatActivityBar = () => {
  const phase = useSelector(selectAiChatActivityPhase);
  const runningToolFriendlyName = useSelector(selectAiChatRunningToolFriendlyName);
  const display = useStickyRunningToolPhase(phase, runningToolFriendlyName, RUNNING_TOOL_HOLD_MS);

  const { statusText, iconSx, textSx } = useMemo(
    () => resolveActivityState(display.phase, display.toolName),
    [display.phase, display.toolName],
  );

  return (
    <Box data-testid={AiChatTestIds.AI_CHAT_ACTIVITY_BAR} sx={activityBarStyles}>
      <Box sx={iconSx}>
        <OmegaIcon size={ACTIVITY_ICON_SIZE} />
      </Box>
      <Typography sx={textSx} variant="regular12">
        {statusText}
      </Typography>
    </Box>
  );
};

export default memo(AiChatActivityBar);
